import "./index.less";
import * as React from "react";
import { BaseAtScale } from "../BaseAtScale";
import { BaseAtScaleGroup } from "../BaseAtScaleGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PrintModeEnum, ScaleType } from "@atman/business";
import { STANINE_SCALE_SEPARATORS } from "../../AtGenericScales";
import { UncontrolledTooltip } from "reactstrap";

export interface IAtBipolarScaleGroupProps {
    onViewCandidateDetailClick?: (candidateProId: string) => void;
}

export class AtBipolarScaleGroup extends BaseAtScaleGroup<IAtBipolarScaleGroupProps> {
    render() {
        const {
            maxScore,
            assessmentType,
            dimensionGroup,
            distributionData,
            distributionViewMode,
            showDistribution,
            distributionMembers,
            expandedDimension,
            onExpandedDimensionChange,
            showHeader = true,
            showDescription = true,
            showFitIndicators,
            interpretationDataEntries,
            printMode,
            onViewCandidateDetailClick,
        } = this.props;

        const tooltipId = `${this.id}-tooltip`;

        let additionalClasses: string = "";
        if (printMode === PrintModeEnum.Detailed) {
            additionalClasses = "detailed";
        }

        return (
            <div className={`AtBipolarScaleGroup ${this.baseClassName} ${additionalClasses}`}>
                {showHeader && (
                    <div className="scale-group-header">
                        {dimensionGroup.name && <h3 className={"group-name"}>{dimensionGroup.name}</h3>}
                        {showDescription && dimensionGroup.description && (
                            <>
                                <FontAwesomeIcon id={tooltipId} icon="question-circle" size="xs" />
                                <UncontrolledTooltip
                                    innerClassName="scale-group-bipolar-tooltip"
                                    placement="right"
                                    target={tooltipId}
                                >
                                    {dimensionGroup.description!.split(/\\n|<br\/><br\/>|<br>|<br\/>/).map((x) => (
                                        <React.Fragment key={x}>
                                            <span>{x}</span>
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </UncontrolledTooltip>
                            </>
                        )}
                    </div>
                )}
                <div className="results-container">
                    {dimensionGroup.dimensions.map((x) => (
                        <BaseAtScale
                            scaleType={ScaleType.Bipolar}
                            dimension={x}
                            maxScore={maxScore}
                            assessmentType={assessmentType}
                            scores={this.getScoresForDimension(x.enumName)}
                            distributionMembers={distributionMembers}
                            distributionEntries={distributionData?.getEntriesForDimension(x.enumName.toCamel())}
                            distributionAverage={distributionData?.getAverageForDimension(x.enumName.toCamel())}
                            // fitScore={this.getFitScore(x)}
                            // analyzedCandidateScore={analyzedCandidateScores?.hasOwnProperty(x.enumName.toCamel()) ? analyzedCandidateScores[x.enumName.toCamel()] : undefined}
                            interpretationData={interpretationDataEntries?.get(x.enumName.toCamel())}
                            distributionViewMode={distributionViewMode}
                            showDistribution={showDistribution}
                            expandedDimension={expandedDimension}
                            onExpandedDimensionChange={onExpandedDimensionChange}
                            showFitIndicators={showFitIndicators}
                            // currentFitLevelFilter={currentFitLevelFilter}
                            key={x.enumName}
                            printMode={printMode}
                            showDescription={printMode === undefined || printMode === PrintModeEnum.Detailed}
                            onViewCandidateDetailClick={onViewCandidateDetailClick}
                            separators={STANINE_SCALE_SEPARATORS}
                        />
                    ))}
                </div>
            </div>
        );
    }
}
